<div class="sidebar-overlay" [class.open]="isOpen" (click)="onClose()">
  <div class="sidebar-container" 
       [class.open]="isOpen" 
       [class.cart]="variant === 'cart'"
       (click)="$event.stopPropagation()">

    <!-- Header do Sidebar -->
    <div class="sidebar-header" *ngIf="showHeader">
      <div class="header-left">
        <ng-container *ngIf="header.icon; else customIcon">
          <mat-icon class="header-icon">{{ header.icon }}</mat-icon>
        </ng-container>
        <ng-template #customIcon>
          <span class="custom__icon" aria-hidden="true" *ngIf="header.customIcon">
            <umkt-icon [icon]="{ name: header.customIcon.name, type: header.customIcon.type }" [size]="'lg'"></umkt-icon>
          </span>
        </ng-template>

        <span class="header-title">
          {{ (header.titleKey ? (header.titleKey | i18n: header.titleParams) : header.title) }}
        </span>
      </div>

      <button class="close-btn" *ngIf="showCloseButton" (click)="onClose()" aria-label="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <!-- Conteúdo do Sidebar via Content Projection -->
    <div class="sidebar-content">
      <ng-content></ng-content>
    </div>

   <div class="sidebar-total font-highlight" *ngIf="variant === 'cart' && showTotal">
      <div class="registry-total" *ngIf="showRegistryTotals; else singleCartTotal">
        <div class="registry-total__price">
          <span>{{ 'pages.orderSummaryCard.totalLabel' | i18n }}</span>
          <span>{{ firstMonthTotal | currencyBRL }}</span>
        </div>
        <p class="registry-total__caption" *ngIf="recurringTotal > 0; else registryOnceCaption">
          {{ 'components.cart.registryTotalCaption' | i18n: { price: (recurringTotal | currencyBRL:false) } }}
        </p>
        <ng-template #registryOnceCaption>
          <p class="registry-total__caption">{{ 'components.cart.registryTotalCaptionOnce' | i18n }}</p>
        </ng-template>
      </div>
      <ng-template #singleCartTotal>
        <div class="total-row">
          <span class="label">{{ totalLabel }}</span>
          <div>
            <span class="value">
              {{ totalValue! | currencyBRL}}
              <span class="value-suffix" *ngIf="totalSuffix">{{ totalSuffix }}</span>
            </span>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="sidebar-footer" *ngIf="variant === 'cart'">
      <button type="button" class="cta" (click)="onFooterClick()" *ngIf="showFooterButton">
        <span class="cta__icon" aria-hidden="true">
          <umkt-icon
            [icon]="{ name: 'pagamento-digital', type: 'mondrian-icons' }"
            [size]="'sm'">
          </umkt-icon>
        </span>
        <span class="cta__label">{{ footerButtonText }}</span>
      </button>
    </div>
  </div>
</div>
